import React, { useEffect } from 'react'
import { SessionRegion, useSessionContext } from 'session'
import { ProtectedPage } from 'pages'
import {
  LegPoliticalPartiesProvider,
  LegSeatStatusProvider,
  UsRoleTypesProvider,
  UsLegRoleTypesProvider,
  UsCountriesLutProvider,
  LegDistrictsProvider,
  RoleResponsibilityProvider,
  UsUrlDescTypeProvider,
  RoleAddressTypeProvider,
  BuildingProvider,
  ExecOrgParentLutProvider,
  ExecRoleLutProvider,
  ProtectedRoleHoldersLutProvider,
  ExecPosTypeLutProvider,
  UsStateLutProvider
} from 'components'
export interface UsPageProps {
  page: React.ReactElement
}

export const UsPage: React.FC<UsPageProps> = ({ page }) => {
  const { sessionData } = useSessionContext()
  useEffect(() => {
    if (sessionData.region !== SessionRegion.US) {
      window.location.href = '/search'
    }
  }, [sessionData.region])

  return <React.Fragment>
        <UsCountriesLutProvider>
          <UsRoleTypesProvider>
            <UsLegRoleTypesProvider>
              <LegSeatStatusProvider>
                <LegPoliticalPartiesProvider>
                  <LegDistrictsProvider>
                    <RoleResponsibilityProvider>
                      <UsUrlDescTypeProvider>
                        <RoleAddressTypeProvider>
                          <BuildingProvider>
                            <ExecOrgParentLutProvider>
                              <ExecRoleLutProvider>
                                <ProtectedRoleHoldersLutProvider>
                                  <ExecPosTypeLutProvider>
                                    <UsStateLutProvider>
                                      <ProtectedPage page={page} />
                                    </UsStateLutProvider>
                                  </ExecPosTypeLutProvider>
                                </ProtectedRoleHoldersLutProvider>
                              </ExecRoleLutProvider>
                            </ExecOrgParentLutProvider>
                          </BuildingProvider>
                        </RoleAddressTypeProvider>
                      </UsUrlDescTypeProvider>
                    </RoleResponsibilityProvider>
                  </LegDistrictsProvider>
                </LegPoliticalPartiesProvider>
              </LegSeatStatusProvider>
            </UsLegRoleTypesProvider>
          </UsRoleTypesProvider>
        </UsCountriesLutProvider>
        </React.Fragment>
}
